import { render, staticRenderFns } from "./QuickscanStep2.vue?vue&type=template&id=299c7e99"
import script from "./QuickscanStep2.vue?vue&type=script&lang=js"
export * from "./QuickscanStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports